export const DOCUMENT_TYPE_BANK_AREA = 'bank-area';
